import React, { useEffect, useState } from 'react'
import { Box, Typography } from '@mui/material'
import { useQuery, useQueryClient } from 'react-query'
import { getForm } from 'services/api/modules/performance/appraisal/form'
import { useLocation, useNavigate } from 'react-router-dom'
import { FormatBacktoFront } from 'module/performance/services/helper/formFunctions'
import AltFormHeader from '../components/altFormHeader'
import AltDisplayQuestion from '../components/altDisplayQuestion'
import PageNavigator from '../components/pageNavigator'

const Alt2ViewForm = () => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const formId = pathname.split('/').pop()
  const queryClient = useQueryClient()
  const [formPage, setFormPage] = useState(0)
  const [quesKeycount, setQuesKeycount] = useState(2)
  const [formTitle, setFormTitle] = useState('')
  const [formDesc, setFormDesc] = useState('')
  // used to store form's title and description
  const [is360, setIs360] = useState(false)
  // used to identify whether form is exclusively for 360 eval or not
  const [formStructure, setFormStructure] = useState([[0]])
  // key in formStructure will link to the corresponding quesKey in the object array in quesParams
  // formStructure determines the sequence of the question
  // 1st layer array represents the form
  // 2nd layer array represents a section
  // each value inside the array is a question
  // value represents the key of the question, used for mapping and dnd
  const [quesParams, setQuesParams] = useState([
    {
      quesKey: 0,
      quesType: '1',
      quesRequired: true,
      question: '',
      option: [],
    },
  ])
  // default question parameter if not replaced by API call's data, store question parameters
  const [sectParams, setSectParams] = useState([
    {
      title: '',
      desc: '',
    },
  ])

  const {
    isLoading,
    error: fetchError,
    data,
  } = useQuery(['formData', formId], async () => {
    const { data } = await getForm(formId)
    return data
  })

  if (fetchError) {
    navigate('/app/management-centre/company-management/appraisal')
  }

  useEffect(() => {
    // if (data?.form?.is_template === 0) {
    //   navigate(`/app/management-centre/company-management/appraisal`)
    // }

    handleFormSpread(data?.form || { sections: [] })
    setFormTitle(data?.form.title || '')
    setFormDesc(data?.form.description || '')
    setIs360(data?.form.is_360_form || false)
  }, [data])

  useEffect(() => {
    queryClient.resetQueries('formData')
    queryClient.invalidateQueries('allFormData')
  }, [])

  //========================================================================================================
  // HANDLING FORM FORMAT CONVERSION BACKEND<>FRONTEND
  //========================================================================================================

  // converting backend form format into frontend form format
  const handleFormSpread = (formObject) => {
    let spreadForm = FormatBacktoFront(formObject)

    setSectParams(spreadForm.sect)
    setQuesParams(spreadForm.ques)
    setFormStructure(spreadForm.form)
    setQuesKeycount(spreadForm.quesCount)
  }

  const getQues = (quesKey) => {
    let items = quesParams?.find((i) => i.quesKey === quesKey)
    return items
  }

  const handleResponse = (quesKey, value) => {
    let items = JSON.parse(
      JSON.stringify(
        quesParams?.splice(
          quesParams?.findIndex((i) => i.quesKey === quesKey),
          1
        )
      )
    )
    //making deep copy of question parameters

    items[0].response = value

    let prevState = quesParams.filter((x) => x.quesKey !== quesKey)
    prevState.push(items[0])
    setQuesParams(prevState)
  }

  const handlePage = (page) => {
    setFormPage(page - 1)
  }

  const handleExit = () => {
    // navigate(`/app/management-centre/company-management/appraisal/form/${formId}`)
    if (window.history.length > 1) {
      navigate(-1)
    } else {
      window.opener = null
      window.open('', '_self')
      window.close()
    }
  }

  return (
    <Box
      sx={{
        backgroundColor: 'gray-background.main',
        minHeight: '100vh',
        maxWidth: '100vw',
      }}
      display="flex"
      flexDirection="column"
    >
      <AltFormHeader
        title={formTitle ? formTitle : 'Untitled Form'}
        pageCount={formStructure?.length || 1}
        pageCurrent={formPage}
        handleExit={handleExit}
      />
      <Box display="flex" flexDirection="column" px={{ xs: 3, sm: 10, lg: 30 }} my={10}>
        <Box
          display="flex"
          flexDirection="column"
          bgcolor="white.main"
          borderRadius={2}
          boxShadow="0px 0px 10px lightgray"
        >
          <Box px={3} py={2} borderBottom={1} borderColor="gray-line.main">
            <Typography variant="h4" color="alternate.main" fontWeight="600">
              {sectParams[formPage] !== undefined ? sectParams[formPage].title : ''}
            </Typography>
            <Typography pt={1} textAlign="justify" variant="body1" color="light-gray-text.main">
              {sectParams[formPage] !== undefined ? sectParams[formPage].desc : ''}
            </Typography>
          </Box>
          <Box display="flex" flexDirection="column" gap={3} px={3} py={2}>
            {formStructure[formPage] !== undefined
              ? formStructure[formPage]?.map((i, index) => (
                  <AltDisplayQuestion
                    quesKey={getQues(i)?.quesKey || 0}
                    valueType={getQues(i)?.quesType || '1'}
                    valueRequired={getQues(i)?.quesRequired || 0}
                    valueQuestion={getQues(i)?.question || ''}
                    valueOption={getQues(i)?.option || []}
                    valueResponse={getQues(i)?.response || ''}
                    handleResponse={handleResponse}
                    formPage={formPage}
                    key={index}
                  />
                ))
              : null}
          </Box>
        </Box>
        <PageNavigator
          pageCount={formStructure?.length || 1}
          pageCurrent={formPage}
          handlePage={handlePage}
          handleExit={handleExit}
          isPreview
        />
      </Box>
    </Box>
  )
}

export default Alt2ViewForm
